module.exports = __webpack_public_path__ + "static/img/pc_07.5a1cb1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/A3/pc_07.png
// module id = by+C
// module chunks = 0